<template>
  <FormProduct :id="id" view />
</template>

<script>
import FormProduct from '@/components/Form/Product'
export default {
  props: {
    id: [String, Number],
  },
  components: {
    FormProduct,
  },
}
</script>

<style></style>
